export default () => ({
  products: null,
});
